import { QueryClient } from '@tanstack/react-query';
import { retryWhileInUse } from './attention';

let queryClient;

export function getOrCreateQueryClient() {
  if (!queryClient) {
    // Retries wait for someone to use the workspace (see attention.js).
    queryClient = new QueryClient({ defaultOptions: { queries: { retry: retryWhileInUse() } } });
  }
  return queryClient;
}
